import React from 'react';

import { Image } from '@mantine/core';
import websiteImage from 'assets/images/onboarding/website.png';
import { BrowserIcon } from 'hugeicons-react';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import { useTranslation } from 'react-i18next';
import { OnboardingLearnMoreInterestsData } from 'shared/interfaces/Onboarding';

const LINKS = {
  LEARN_MORE: 'https://docs.droxy.ai/documentation/agents/website'
};

interface WebsiteSmartAssistantsStepProps {
  updateOnboardingLearnMoreInterestData: (data: Partial<OnboardingLearnMoreInterestsData>) => void;
}

export function WebsiteSmartAssistantsStep({ updateOnboardingLearnMoreInterestData }: WebsiteSmartAssistantsStepProps) {
  const { t } = useTranslation();

  const updateLearnMoreInterestData = () => updateOnboardingLearnMoreInterestData({ websiteSmartAssistant: true });

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.WEBSITE_SMART_ASSISTANTS_STEP.TITLE'),
        icon: <BrowserIcon />
      }}
      description={t('ONBOARDING.WEBSITE_SMART_ASSISTANTS_STEP.DESCRIPTION')}
      learnMore={{
        link: LINKS.LEARN_MORE,
        onClick: updateLearnMoreInterestData
      }}
      rightElement={<Image src={websiteImage} />}
    />
  );
}
